import { atom } from 'jotai'
import { MEMBERSHIP_MODAL_STEPS } from 'src/modules/Modals/constants'

export const membershipModalAtom = atom({
  step: MEMBERSHIP_MODAL_STEPS.introduction,
  isOpen: false,
  isRejoin: false
})
